

function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

function isValidDate(dateString) {
    if (!dateString) return false;

    var dateRegex = /^(\d{1,2})[-_/](\d{1,2})[-_/](\d{2}|\d{4})$/;

    if (!dateRegex.test(dateString)) return false; 

    var matches = dateString.match(dateRegex);
    var month = parseInt(matches[1]) - 1; 
    var day = parseInt(matches[2]);
    var year = parseInt(matches[3]);

    if (year < 100) {
        var currentYear = new Date().getFullYear();
        var currentCentury = Math.floor(currentYear / 100) * 100;
        if (year > currentYear % 100) {
            year += currentCentury - 100;
        } else {
            year += currentCentury;
        }
    }

    var date = new Date(year, month, day);

    return (
        date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day
    );
}

function setCookie(cookieName, cvalue, exdays) {
    const d = new Date();
    d.setTime(exdays);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cookieName + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cookieName) {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function getCookieExpiration(cookieName) {
    const cookies = document.cookie;

    const cookieArray = cookies.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();

        if (cookie.startsWith(cookieName + '=')) {
            const cookieValue = cookie.substring(cookieName.length + 1);

            const cookieParts = cookieValue.split(';');
            for (let j = 0; j < cookieParts.length; j++) {
                const part = cookieParts[j].trim();
                if (part.startsWith('expires=')) {
                    const expirationDateString = part.substring('expires='.length);
                    return new Date(expirationDateString);
                }
            }
        }
    }

    return null;
}

function createFullscreenButton(name) {
    let div = document.createElement('div');
    div.setAttribute('role', 'button');
    div.setAttribute('tabindex', '0');
    div.setAttribute('alt', 'Enter full screen');
    div.setAttribute('title', 'Enter full screen');
    div.className = name + '-full-screen-button full-screen-img fade-full-screen';
    return div;
}

function exitFullScreen(event) {

    if (!document.fullscreenElement &&
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement) {

        try {

            if (event && event.target) {
                let id = event.target.id;

                $('#' + id).addClass(id);
                $('#' + id + 'Viewer').removeClass(id + 'Viewer-full-screen');

            }
            switch (paoDetails.support.fullscreenApi) {
                case 'Unknown':
                    document.exitFullscreen();
                    break;
                case 'WebKit':
                    document.webkitExitFullscreen();
                    break;
                case 'Gecko':
                    document.mozCancelFullScreen();
                    break;
                case 'IE':
                    $('#taxbillIFrame').toggleClass('taxBill-full-screen');
                    document.msExitFullscreen();
                    break;
                default: 
            } 
        } catch (error) {
            console.log(error);
        }
    }
}

function addExitFullscreenEventListener(id) {
    try {

        let _type = 'fullscreenchange';

        switch (paoDetails.support.fullscreenApi) {
            case 'Unknown':
                break;
            case 'WebKit':
                _type = 'webkitfullscreenchange';
                break;
            case 'Gecko':
                _type = 'mozfullscreenchange';
                break;
            case 'IE':
                _type = 'MSFullscreenChange';
                break;
            default: 
        }
        document.addEventListener(_type, exitFullScreen);

    } catch (error) {
        console.log(error);
    }
}

function detectMobileDevice() {

    let a = navigator?.userAgentData;
    if (a) return a.mobile;

    if (Modernizr && Modernizr.touchevents) {
        let UA = navigator.userAgent;
        return (/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA));
    }
    return false;
};

function detectBrowser() {
}

function detectWebGL() {
    if (!Modernizr) return false;
    return Modernizr.webgl;
}

function checkDeviceBrand(name) {
    let a = navigator?.userAgentData;
    if (a) {
        let n = a.brands.find(({ brand }) => brand.indexOf(name) > -1);
        if (n) return true;

        return false;
    }
    return navigator.userAgent.indexOf(name) > -1;

}

function detectSupportedDevice() {
    let supported = true;



    let viewportWidth = window.innerWidth;

    let viewportHeight = window.innerHeight;


    let browserWidth = window.outerWidth;

    let browserHeight = window.outerHeight;

    let screenWidth = window.screen.width;
    let screenHeight = window.screen.height;




    return viewportWidth >= 1024 && viewportHeight >= 768;
};

function getUserAgent() {

    let sUsrAg = navigator.userAgent;
    if (sUsrAg.indexOf('Firefox') > -1) {
        return 'Gecko';
    } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
        return 'WebKit';
    } else if (sUsrAg.indexOf('Trident') > -1) {
        return 'IE';
    } else if (sUsrAg.indexOf('Edge') > -1) {
        return 'WebKit';
    } else if (sUsrAg.indexOf('Chromium') > -1) {
        return 'WebKit';
    } else if (sUsrAg.indexOf('Safari') > -1) {
        return 'WebKit';
    } else if (sUsrAg.indexOf('Microsoft') > -1) {
        return 'Gecko';
    } else {
        return 'Unknown'; 
    }
}

function debugResolution() {

    let rezW = window.screen.width;
    let resH = window.screen.height;

    let $div = $('<div>', { 'class': 'resolution-box' });
    let $span = $('<span>', { 'class': 'resolution-info' }).text(rezW + ' X ' + resH);

    $('.resolution-box').remove();
    $div.append($span);
    $('#header').append($div);

}

Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

window.formatCurrency = function (amount) {
    let options2 = { style: 'currency', currency: 'USD' };
    let numberFormat2 = new Intl.NumberFormat('en-US', options2);
    return numberFormat2.format(amount);
};

window.chartOptions = function () {
    return {
        chartArea: { left: 1, top: 25, width: '100%', height: '89%' },
        colors: ['#00A8E8', '#FCBF49', '#0EAD69', '#FF3C38', '#DD0D03'],
        is3D: true,
        legend: { position: 'labeled', alignment: 'start', textStyle: { color: '#E02F2F', fontName: 'Source+Sans+Pro', fontSize: 13 } },
        pieSliceText: 'value',
        pieSliceTextStyle: { color: '#fff', fontName: 'Source+Sans+Pro', fontSize: 14 },
        pieStartAngle: -65,
        slices: { 0: { color: '#0c4ca0' }, 1: { color: '#d4b515' }, 2: { color: '#26A96C' }, 3: { color: '#e02b13' }, 4: { color: '#D74E09' } },
        sliceVisibilityThreshold: 0,
        titleTextStyle: { color: '#496799', fontName: 'Source+Sans+Pro', fontSize: 12 },
        tooltip: { showColorCode: true, ignoreBounds: false, text: 'both', trigger: 'focus' }
    };
};

window.getFullscreenApiSupport = function () {
    let agent = getUserAgent();
    let tf = true;
    switch (agent) {
        case 'WebKit':
            if (document.webkitFullscreenEnabled) {
                paoDetails.support.fullscreenApi = 'WebKit';
            }
            break;
        case 'Gecko':
            if (document.mozFullScreenEnabled) {
                paoDetails.support.fullscreenApi = 'Gecko';
            }
            break;
        case 'IE':
            if (document.msFullscreenEnabled) {
                paoDetails.support.fullscreenApi = 'IE';
            }
            break;
        case 'Unknown':
            if (document.fullscreen || document.fullscreenEnabled) {
                paoDetails.support.fullscreenApi = 'Unknown';
            }
            break;
        default:
            paoDetails.support.fullscreenApi = 'Not Supported';
            paoDetails.support.fullscreenSupported = false;
            tf = false;
    }
    return tf;
};

async function copyOperation(event) {
    let id = event?.data?.id;
    if (id) {
        const article = document.querySelector('#' + id);
        article.select();
        await navigator.clipboard.writeText(article.innerHTML);
        $('#' + id).attr('data-original-title', 'Copied').tooltip('show');
    }
}

window.copy = function (event) {
    try {
        let copied = document.querySelector('#' + event.data.id);
        copied.select();
        document.execCommand('copy');
        $('#' + event.data.id).attr('data-original-title', 'Copied').tooltip('show');
    } catch (err) {
        console.log(err);
    }
};

window.download = function (event) {
    let content = document.querySelector('#' + event.data.id).value;
    let filename = paoDetails.context.parid + '.txt';
    let blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, filename);
};

const mediaQueryList = window.matchMedia('(orientation: portrait)');

function handleOrientationChange(evt) {
    console.log(`devicePixelRatio: ${window.devicePixelRatio}`);
    if (evt.matches) {
        console.log('The viewport is currently in portrait orientation.');
    } else {
        console.log('The viewport is currently in landscape orientation.');
    }
}

handleOrientationChange(mediaQueryList);

mediaQueryList.addEventListener('change', handleOrientationChange);

